/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

export const EvalsKaryaColors = {
  teal: '#0A313C',
  tealLight: '#035E77',
  tealDark: '#002029',
  tealGradient1: '#2F525C50',
  white: '#F6F6F6',
  white20: '#FFFFFF33',
  white10: '#FFFFFF1A',
  beige: '#F2EDE7',
  lightBeige: '#FAF7F4',
  heroText: '#DFFEF3',
  secondaryBlue: '#00AFDF',
  secondaryBlue2: '#90E7FF',
  lighterBlue: '#C7EAF1',
  buttonCta: '#055369',
  buttonCtaHover: '#044354',
  grey: '#C6C6C6',
  grey10: '#2F525C',
  grey20: '#ACACAC',
  errorBg: '#FEF2F2',
  errorBorder: '#FECACA',
  errorText: '#DC2626',
  errorSolid: '#DC2626',
} as const;
